export default /* @ngInject */ function($log, $timeout, userPermissions) {
    return {
        restrict: 'A',
        scope: {
            userCan: '='
        },
        template: '<ng-transclude ng-if="show"></ng-transclude>',
        transclude: true,
        link: function($scope) {
            let action = $scope.userCan;
            if (action) {
                userPermissions.can(action)
                    .then((can) => $scope.show = can);
            } else {
                $scope.show = true;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./user/directives/user-can.directive.js